import { companyId } from 'helpers/userSessionSettings';

export const COMPANY_SCOPED_KEY_PATTERN = /^c-\d+--/;

export function buildStorageKeyForCompany(targetCompanyId, key) {
  return `c-${targetCompanyId}--${key}`;
}

/**
 * Builds unified template storage key
 * @param key - initial key string
 * @return local storage key in company namespace
 */
export default function buildStorageKeyFor(key) {
  return buildStorageKeyForCompany(companyId, key);
}
